import { THREAD_SURFACE_MODES, THREAD_SURFACE_MODE_STATES, THREAD_SURFACE_SCROLL_OWNERS } from '@/lib/threadSurface/threadSurfacePresentationConstants.js';

const normalizeThreadSurfacePresentation = (payload) => {
  if (!payload || typeof payload !== 'object' || Array.isArray(payload)) {
    return null;
  }

  const nextMode = String(payload?.mode || '').trim();
  const nextModeState = String(payload?.modeState || '').trim();
  const nextScrollOwner = String(payload?.scrollOwner || '').trim();

  if (!THREAD_SURFACE_MODES.includes(nextMode)) {
    return null;
  }

  if (!THREAD_SURFACE_MODE_STATES.includes(nextModeState)) {
    return null;
  }

  if (!THREAD_SURFACE_SCROLL_OWNERS.includes(nextScrollOwner)) {
    return null;
  }

  return {
    mode: nextMode,
    modeState: nextModeState,
    scrollOwner: nextScrollOwner
  };
};

export default normalizeThreadSurfacePresentation;
